import { GADataProps } from "@components/GAData/GAData";

export const THRIVE_EVENTS_GA_PROPS: GADataProps = {
  title: "Thrive Events",
  level2: "miscellaneous",
  cd_version: "bt2",
};
